module.exports = __webpack_public_path__ + "img/mountains.9461522f.jpg";